import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, Loader2 } from 'lucide-react';

interface RefreshButtonProps {
  onClick: () => void;
  loading?: boolean;
  label?: string;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

/**
 * Shared refresh button component
 * Used in: KBDocumentsPage, KBEntityTypesPage, KBValidationPage
 */
const RefreshButton: React.FC<RefreshButtonProps> = ({
  onClick,
  loading = false,
  label = 'Refresh',
  variant = 'outline',
  size = 'default',
}) => {
  return (
    <Button variant={variant} size={size} onClick={onClick} disabled={loading}>
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <RefreshCw className="h-4 w-4" />
      )}
      {label && <span className="ml-2">{label}</span>}
    </Button>
  );
};

export default RefreshButton;
